import { getParentOfType, types } from 'mobx-state-tree';

import FullProduct from './FullProduct';
import FullProductCollectionItem from './FullProductCollectionItem';
import ProductMatrix from './ProductMatrix';
import ProductProperty from './ProductProperty';

const FullProductMatrix = types.compose(
  ProductMatrix,
  types
    .model('FullProductMatrix', {
      row: ProductProperty,
      column: ProductProperty,
      items: types.array(FullProductCollectionItem),
    })
    .views((self) => {
      return {
        get product() {
          return getParentOfType(self, FullProduct);
        },
      };
    })
);

export default FullProductMatrix;
